export default `
  query getProductSwatchImages(
      $filter: ProductAttributeFilterInput
  ) {
        products(filter: $filter) {
            items {
                ... on ConfigurableProduct {
                    configurable_options {
                        values {
                            swatch_data {
                            value
                            thumbnail
                        }
                    }
                }
            }
        }
    }
  }
`;
